<template>
  <auth-loader />
</template>

<script>
  /* eslint-disable */
export default {
  name: "LoginPage",
  components: {
     AuthLoader: () => import("../../components/auth-loader/auth-loader.vue"),
  },
  computed: {},
  created() {
    (async () => {
      this.$auth.signInWithRedirect()
    })()
  }
};
</script>
